import { useState, useEffect } from 'react';
import { CategoryCard } from './CategoryCard';
import type { Category } from '@shared/types/product.types';

export function CategoryGrid() {
  const [categories, setCategories] = useState<(Category & { _count?: { products: number } })[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch('/api/categories')
      .then((res) => res.json())
      .then((json) => {
        setCategories(json.data || []);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="animate-pulse rounded-xl border border-white/10 bg-navy-900/50 p-6">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-navy-800" />
              <div className="space-y-2">
                <div className="h-4 w-20 rounded bg-navy-800" />
                <div className="h-3 w-16 rounded bg-navy-800" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {categories.map((category) => (
        <CategoryCard
          key={category.id}
          name={category.name}
          slug={category.slug}
          description={category.description}
          icon={category.icon}
          productCount={category._count?.products ?? 0}
        />
      ))}
    </div>
  );
}
